import { useMedia } from 'tamagui'
import { PixelRatio, Platform } from 'react-native'

export type ImageContext = 'card' | 'hero'

const getDevicePixelRatio = (): number => {
  if (Platform.OS === 'web') {
    return typeof window !== 'undefined' && window.devicePixelRatio 
      ? window.devicePixelRatio 
      : 2
  }
  return PixelRatio.get()
}

export const useResponsiveImageUrl = (originalUrl: string, context: ImageContext): string => {
  const media = useMedia()
  
  if (!originalUrl || !originalUrl.includes('/public')) {
    return originalUrl
  }
  
  // Get actual device pixel ratio
  const dpr = getDevicePixelRatio()
  
  let baseWidth: number
  
  if (context === 'card') {
    // LessonCard physical display widths
    baseWidth = media.gtMd ? 267 : media.gtSm ? 229 : 160
    // Cap at 3x for efficiency (diminishing returns beyond that)
    const width = Math.round(baseWidth * Math.min(dpr, 3))
    return originalUrl.replace('/public', `/w=${width}`)
  } else {
    // LessonContent hero image - estimate viewport usage
    if (media.gtMd) {
      baseWidth = 1200 // Desktop viewport estimate
    } else if (media.gtSm) {
      baseWidth = 768 // Tablet viewport estimate
    } else {
      baseWidth = 428 // Max mobile viewport (iPhone 14 Pro Max)
    }
    
    // Cap at 2x for large images (good balance of quality vs file size)
    const width = Math.round(baseWidth * Math.min(dpr, 2))
    return originalUrl.replace('/public', `/w=${width}`)
  }
}